import React from "react";
import { Table } from "reactstrap";

const DevicesTable = ({ devices }) => {
  if (!devices || devices.length === 0) return <div className="text-muted">No devices available for this site.</div>;

  return (
    <Table bordered responsive size="sm">
      <thead className="thead-light">
        <tr>
          <th>Type</th>
          <th>Brand & Family</th>
          <th>Name</th>
          <th>Model</th>
          <th>Local IP</th>
        </tr>
      </thead>
      <tbody>
        {devices.map((device, index) => (
          <tr key={index}>
            <td>{device.device_type}</td>
            <td>{device.brand_and_family}</td>
            <td>{device.display_name}</td>
            <td>{device.model}</td>
            <td>{device.local_ip}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DevicesTable;